import React from 'react';
import type { AgoraParticipantLike } from '../../types';
import Publication from '../Publication/Publication';
import usePublications from '../../hooks/usePublications/usePublications';

interface ParticipantTracksProps {
  participant: AgoraParticipantLike;
  videoOnly?: boolean;
  enableScreenShare?: boolean;
  videoPriority?: unknown;
  isLocalParticipant?: boolean;
}

export default function ParticipantTracks({
  participant,
  enableScreenShare,
  videoPriority,
  isLocalParticipant,
}: ParticipantTracksProps) {
  const publications = usePublications(participant);

  const filtered = enableScreenShare && publications.some(p => p.trackName.includes('screen'))
    ? publications.filter(p => p.trackName.includes('screen') || p.kind !== 'video')
    : publications.filter(p => !p.trackName.includes('screen'));

  return (
    <>
      {filtered.map(pub => (
        <Publication
          key={pub.kind + pub.trackName}
          publication={pub}
          participant={participant}
          isLocalParticipant={isLocalParticipant}
          videoPriority={videoPriority}
        />
      ))}
    </>
  );
}
